import { Component, Input } from '@angular/core';
import {
    type ConvocatedUserPreview,
    type ConvocationRowItem,
    convocationCityLine,
    convocationDirectionsUrl,
    isConvocationLink,
    relativeConvocationDay,
} from '../mister-convocation-shared';

const DESCRIPTION_PREVIEW_LENGTH = 220;
const AVATAR_PREVIEW_COUNT = 4;

@Component({
    selector: 'app-dashboard-mister-latest-convocation-card',
    templateUrl: './latest-convocation-card.component.html',
    styleUrls: ['./latest-convocation-card.component.scss'],
})
export class DashboardMisterLatestConvocationCardComponent {
    @Input() convocation: ConvocationRowItem | null = null;
    @Input() invitedUsers: ConvocatedUserPreview[] = [];
    @Input() loading = false;
    @Input() invitedLoading = false;

    invitedAccordionExpanded = false;
    descriptionExpanded = false;

    readonly avatarPreviewCount = AVATAR_PREVIEW_COUNT;

    statusClass(status: string): string {
        const key = status.toLowerCase();
        if (
            key.includes('pubblicat') ||
            key.includes('open') ||
            key.includes('attiv') ||
            key === 'active'
        ) {
            return '!bg-emerald-50 !text-emerald-800 !ring-emerald-600/15';
        }
        if (key.includes('bozz') || key.includes('draft')) {
            return '!bg-amber-50 !text-amber-800 !ring-amber-600/15';
        }
        if (
            key.includes('chius') ||
            key.includes('annull') ||
            key.includes('cancell')
        ) {
            return '!bg-zinc-100 !text-zinc-700 !ring-zinc-500/10';
        }
        return '!bg-sky-50 !text-sky-800 !ring-sky-600/15';
    }

    relativeDay(date: string): { label: string; past: boolean } | null {
        return relativeConvocationDay(date);
    }

    isLink(value: string): boolean {
        return isConvocationLink(value);
    }

    cityLine(c: ConvocationRowItem): string {
        return convocationCityLine(c);
    }

    directionsUrl(c: ConvocationRowItem): string | null {
        return convocationDirectionsUrl(c);
    }

    isDescriptionLong(description: string): boolean {
        return (description?.trim().length ?? 0) > DESCRIPTION_PREVIEW_LENGTH;
    }

    initials(fullName: string): string {
        return fullName
            .split(/\s+/)
            .filter(Boolean)
            .slice(0, 2)
            .map((part) => part[0]?.toUpperCase())
            .join('');
    }

    toggleInvitedAccordion(): void {
        this.invitedAccordionExpanded = !this.invitedAccordionExpanded;
    }

    trackUserId(_i: number, u: ConvocatedUserPreview): string {
        return u.id;
    }
}
